import Vue from 'vue'
import App from './App.vue'
import 'animate.css';
import './elementd'
import VWave from 'v-wave';
import VueCompositionAPI from '@vue/composition-api';
import '../src/style/index.scss'
import './registerServiceWorker';
import '../src/utils/flexible'
import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import zh from './locales/zh.json';
import jpn from './locales/jpn.json';

Vue.use(VueCompositionAPI);
Vue.use(VWave, {
  color: 'rgb(255,255,255)', // 自定义颜色
  duration: 0.4,              // 自定义持续时间（秒）
  easing: 'ease-out',         // 自定义缓动效果
});

// 安装 VueI18n 插件
Vue.use(VueI18n);

// 配置 i18n 实例
const i18n = new VueI18n({
  locale: 'zh',  // 设置默认语言
  messages: {
    en,
    zh,
    jpn
  }
});


Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App),
  // mounted() {
  //   // Vue 实例挂载完成后隐藏加载页面
  //   const loadingElement = document.getElementById('container');
  //   if (loadingElement) {
  //     loadingElement.style.display = 'none';
  //   }
  //   // 显示主应用
  //   const appElement = document.getElementById('app');
  //   if (appElement) {
  //     appElement.style.display = 'block';
  //   }
  // }
}).$mount('#app')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      console.log('Service Worker registered: ', registration);

      // 检查是否有新的 Service Worker
      // if (registration.waiting) {
      //   registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      // }

      // 监听更新事件
      registration.onupdatefound = () => {
        const newWorker = registration.installing;
        newWorker.onstatechange = () => {
          if (newWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('New content is available; please refresh.');
              // 提示用户刷新页面
              Vue.prototype.$confirm('新版本可用，点击确定刷新页面。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                window.location.reload();
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
              });
            } else {
              console.log('Content is cached for offline use.');
            }
          }
        };
      };
      // 处理已安装的 Service Worker 的更新
      navigator.serviceWorker.ready.then(registration => {
        if (registration.waiting) {
          Vue.prototype.$confirm('新版本可用，点击确定刷新页面。', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            window.location.reload();
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }
      });
    }).catch(error => {
      console.log('Service Worker registration failed: ', error);
    });
  });
}

